<template>
  <SelectInput
    :model-value="null"
    :options="QUESTION_TYPES"
    hide-placeholder
    inline
    placeholder="+ Add an item…"
    data-cy="add-question"
    @update:model-value="(type) => emit('add', type)"
  >
    <template #option="{ option }">
      <CustomFormTypeOption
        :option="option"
        :data-cy="`add-type-${option.value}`"
      />
    </template>
  </SelectInput>
</template>

<script setup lang="ts">
import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";
import { QUESTION_TYPES } from "./customFormFields";
import CustomFormTypeOption from "./CustomFormTypeOption.vue";

// The "add" control is the type dropdown itself: picking a type appends a new
// question of that type (there is no blank-then-configure step). modelValue is
// never bound back, so the control always resets to its "+ Add an item…" label.
const emit = defineEmits<{ add: [type: string] }>();
</script>
